import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
// import Cookies from 'universal-cookie';
import Button from "react-bootstrap-button-loader";
import {
  fetchEventDetailsForGuest,
  refreshSessionToken,
  loginToEvent,
  initiateCreateEvent,
  openEventChooser,
  getClientEventStatus,
  createEventInsideDashboard,
} from "Actions";
import { proceedToDashboard, proceedToLogin } from "SignupActions";
import { prefilledLogin, guestSignup, scratchGuestLogin } from "InitialAction";
import { NEW_IMAGE_PATH, isMobile, chooserPopupHeight } from "Constants";
import LocaleStrings from "Languages";
import Loader from "Loader";

class Choose extends Component {
  constructor(props) {
    super(props);
    //const cookies = new Cookies();

    this.state = { loading: false };
  }

  componentDidMount() {
    // This code is added if any one try to go to preview page, without login it will redirect to login page as we are not allowing to add guest user
    var { session, user, existinguser } = this.props;
    if (!existinguser && (session.sessionToken == "" || user.userid == "")) {
      this.props.history.push("/login");
    }
  }

  componentWillMount() {
    // if (isMobile) {
    //   if (this.props.isLoggedIn === true) this.props.logout(this.props.session);
    //   this.props.history.push("/mobile");
    // }
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.moveToDashboard === true) {
      if (this.props.history.location.pathname !== "/dashboard") {
        this.props.history.push("/dashboard");
      }
    } else if (this.props.isLoggedIn === true) {
      if (this.props.history.location.pathname !== "/dashboard") {
        this.props.history.push("/dashboard");
      }
    }

    if (isMobile) {
      if (this.props.isLoggedIn === true) this.props.logout(this.props.session);

      this.props.history.push("/mobile");
    }
  }

  startFromScratch = () => {
    this.setState({ loading: true });
    if (this.props.existinguser) {
      setTimeout(() => {
        this.scratchPrefilledLoginWithoutSignup();
      }, 3000);
    } else {
      setTimeout(() => {
        this.scratchPrefilledLogin();
      }, 3000);
    }
  };

  scratchPrefilledLogin = () => {
    this.props.guestSignup((response) => {
      if (response.success === 1) {
        const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
        var values = {
          userid: this.props.user.userid,
          email: this.props.user.email,
          timezone: tz,
        };
        this.props.scratchGuestLogin(this.props.session, values, (data) => {
          this.props.refreshSessionToken(
            this.props.session,
            { appuserid: data.appuserid },
            (res) => {
              this.props.fetchEventDetailsForGuest(
                this.props.user,
                this.props.session,
                (response) => {
                  // this.setState({loading:false});
                  if (response.success === 1) {
                    this.props.proceedToDashboard();
                  }
                }
              );
            }
          );
        });
      }
    });
  };

  scratchPrefilledLoginWithoutSignup = () => {
    const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
    var values = {
      userid: this.props.user.userid,
      email: this.props.user.email,
      timezone: tz,
    };

    if (
      this.props.user.isSuperAdmin &&
      this.props.user.groupNumber &&
      this.props.user.groupNumber != ""
    ) {
      values = {
        userid: this.props.user.userid,
        email: this.props.user.email,
        groupNumber: this.props.user.groupNumber,
        clientid: this.props.user.clientid,
        timezone: tz,
      };
    }

    this.props.scratchGuestLogin(this.props.session, values, ({ data }) => {
      this.props.refreshSessionToken(
        this.props.session,
        { appuserid: data.appuserid },
        (res) => {
          this.props.getClientEventStatus(
            this.props.user,
            this.props.session,
            (response) => {
              this.props.openEventChooser({ showModal: false });
              this.props.initiateCreateEvent({ initiate: false });
              this.props.loginToEvent(data);
              this.props.proceedToDashboard();

              // Created new event inside dashboard
              if (this.props.insideDashBoard)
                this.props.createEventInsideDashboard(true);
            }
          );
        }
      );
    });
  };

  startPrefilled = () => {
    this.setState({ loading: true });
    if (this.props.existinguser) {
      setTimeout(() => {
        this.prefilledLoginWithoutSignup();
        // debugger;
      }, 3000);
    } else {
      setTimeout(() => {
        this.prefilledLogin();
      }, 3000);
    }
  };

  prefilledLogin = () => {
    this.props.guestSignup((response) => {
      if (response.success === 1) {
        const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
        var values = {
          userid: this.props.user.userid,
          email: this.props.user.email,
          timezone: tz,
        };

        this.props.prefilledLogin(this.props.session, values, (data) => {
          this.props.refreshSessionToken(
            this.props.session,
            { appuserid: data.appuserid },
            (res) => {
              this.props.fetchEventDetailsForGuest(
                this.props.user,
                this.props.session,
                (response) => {
                  // this.setState({loading:false});
                  if (response.success === 1) {
                    this.props.proceedToDashboard();
                  }
                }
              );
            }
          );
        });
      }
    });
  };

  prefilledLoginWithoutSignup = () => {
    const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
    var values = {
      userid: this.props.user.userid,
      email: this.props.user.email,
      timezone: tz,
    };

    if (
      this.props.user.isSuperAdmin &&
      this.props.user.groupNumber &&
      this.props.user.groupNumber != ""
    ) {
      values = {
        userid: this.props.user.userid,
        email: this.props.user.email,
        groupNumber: this.props.user.groupNumber,
        clientid: this.props.user.clientid,
        timezone: tz,
      };
    }

    this.props.prefilledLogin(this.props.session, values, ({ data }) => {
      this.props.refreshSessionToken(
        this.props.session,
        { appuserid: data.appuserid },
        (res) => {
          this.props.getClientEventStatus(
            this.props.user,
            this.props.session,
            (response) => {
              this.props.openEventChooser({ showModal: false });
              this.props.initiateCreateEvent({ initiate: false });
              this.props.loginToEvent(data);
              this.props.proceedToDashboard();

              // Created new event inside dashboard
              if (this.props.insideDashBoard)
                this.props.createEventInsideDashboard(true);
            }
          );
        }
      );
    });
  };

  gotoLoginScreen = () => {
    this.props.history.push("/login");
  };

  render() {
    var cssstyles = "template-container";
    var innerStyle = null;
    if (this.props.existinguser) {
      cssstyles = "template-container-fixed";
      innerStyle = {
        height: chooserPopupHeight,
      };
    }
    return (
      <div className="h-full" style={{ background: "#3f4458" }}>
        {this.state.loading || this.props.existinguser ? null : (
          <div style={{ position: "absolute", right: 50, top: 50 }}>
            <Button
              type="button"
              style={{ width: 95 }}
              className="btn btn-custom-blue"
              onClick={this.gotoLoginScreen}
            >
              {LocaleStrings.login}
            </Button>
          </div>
        )}
        <div className={cssstyles}>
          {this.state.loading ? (
            <div className="loader-container">
              <Loader />
            </div>
          ) : (
            <div className="template-subcontainer">
              <div className="row">
                <div className="col-md-12 col-lg-12">
                  <div className="template-title">
                    {LocaleStrings.choose_template}
                  </div>
                  <div className="template-subtitle">
                    {LocaleStrings.choose_template_subheading}
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-6 col-lg-6">
                  <div
                    className="template-card"
                    onClick={this.startPrefilled.bind(this)}
                  >
                    <div>
                      <img
                        className="template-image"
                        src={NEW_IMAGE_PATH + "/landing_icons/filled_demo.png"}
                      />
                    </div>
                    <div className="template-card-title">
                      {LocaleStrings.pre_filled_demo_event}
                    </div>
                    <div className="template-card-suggestion">
                      ({LocaleStrings.recommended})
                    </div>
                  </div>
                </div>
                <div className="col-md-6 col-lg-6">
                  <div
                    className="template-card"
                    onClick={this.startFromScratch.bind(this)}
                  >
                    <div>
                      <img
                        className="template-image"
                        src={
                          NEW_IMAGE_PATH + "/landing_icons/start_scratch.png"
                        }
                      />
                    </div>
                    <div className="template-card-title">
                      {LocaleStrings.start_with_scratch}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    session: state.session,
    user: state.user,
    isLoggedIn: state.isLoggedIn,
    moveToDashboard: state.moveToDashboard,
  };
}

export default withRouter(
  connect(mapStateToProps, {
    prefilledLogin,
    scratchGuestLogin,
    guestSignup,
    proceedToDashboard,
    proceedToLogin,
    fetchEventDetailsForGuest,
    refreshSessionToken,
    loginToEvent,
    openEventChooser,
    initiateCreateEvent,
    getClientEventStatus,
    createEventInsideDashboard,
  })(Choose)
);
